import { useContext, useEffect, useState, useMemo } from 'react'
import PageWrapper from '/components/page-wrapper'
import { enqueueSnackbar } from 'notistack'

import HelpText from '/help/active-passes'
import { getActivePassesCount } from '/providers/passes-api'
import { AppContext } from '/providers/app-context'
import ActivePassesTable from '/components/passes/active-passes-table'
import Menu from '/components/passes/active-passes-nav-menu'

const ActivePasses = () => {

  const {apiSource, apiKeys, client} = useContext(AppContext)
  const [templates, setTemplates] = useState([])

  useEffect(() => {
    getPasses()
  },[])

  const getPasses = async () => {
    const result = await getActivePassesCount({apiSource, apiKeys})
    if (result.error) {
      enqueueSnackbar({ message: result.error.message ?? "error getting active pass count from server", variant: 'error' })
    } else {
      setTemplates(result.templates)
    }
  }

  const heading = useMemo(() => {
    let heading = "Active Passes" 
    
    if (client.billing_mode === "prepay")  heading += ` (${templates.length} of ${client.max_active_passes})`

    return heading
  }, [templates])

  return (
    <PageWrapper title="Active Passes" HelpText={HelpText} heading={heading} menu={<Menu/>}>
      <div className='flex flex-col gap-5 overflow-y-scroll h-full'>
        <ActivePassesTable activePasses={templates}/>
      </div>
    </PageWrapper>
  )
}


export default ActivePasses